import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UnautorizedComponent } from './unautorized.component';

@NgModule({
  declarations: [UnautorizedComponent],
  exports: [UnautorizedComponent],
  imports: [CommonModule, RouterModule],
})
export class UnautorizedModule {}
